import * as React from 'react';
import { ModalWindow } from '../../../../modal';
import { SingleSelectItem } from '../../../internal';
import * as styles from './styles.css';
export function SelectMobileModal(props) {
  var open = props.open,
    onClose = props.onClose,
    options = props.options,
    onChange = props.onChange,
    value = props.value,
    title = props.title;
  var handleChange = function handleChange(v) {
    if (onChange) {
      onChange(v);
    }
    onClose();
  };
  return /*#__PURE__*/React.createElement(ModalWindow, {
    fixed: true,
    open: open,
    onClose: onClose,
    title: title,
    width: 648
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['items'],
    role: "listbox"
  }, options.map(function (option) {
    var selected = value === option.value;
    return /*#__PURE__*/React.createElement(SingleSelectItem, {
      key: String(option.value),
      option: option,
      selected: selected,
      onClick: function onClick() {
        handleChange(option.value);
      },
      role: "option",
      "aria-selected": selected ? 'true' : undefined
    });
  })));
}